import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { useLang } from "@/i18n/LanguageContext";

export default function Blog() {
  const { t, lang } = useLang();
  const pick = (o, f) => (lang === "es" && o && o[`${f}_es`]) || (o ? o[f] : "");
  const [posts, setPosts] = useState([]);
  useEffect(() => { api.get("/blog").then((r) => setPosts(r.data)).catch(() => {}); }, []);

  const [featured, ...rest] = posts;

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 py-10">
      <div className="mb-8">
        <p className="text-xs uppercase tracking-[0.2em] text-primary font-semibold">{t("blog.eyebrow")}</p>
        <h1 className="font-heading text-3xl sm:text-4xl font-bold mt-1">{t("blog.title")}</h1>
        <p className="text-muted-foreground mt-2">{t("blog.sub")}</p>
      </div>

      {featured && (
        <Link to={`/blog/${featured.slug}`} className="group grid md:grid-cols-2 gap-6 rounded-3xl border border-border overflow-hidden bg-white mb-10 hover:shadow-lg transition-shadow" data-testid={`blog-featured-${featured.slug}`}>
          <img src={featured.cover_image} alt={featured.title} className="h-64 md:h-full w-full object-cover" />
          <div className="p-8 flex flex-col justify-center">
            <div className="flex gap-2 mb-3">{featured.tags?.map((tg) => <span key={tg} className="text-xs bg-primary/5 text-primary rounded-full px-2.5 py-0.5">{tg}</span>)}</div>
            <h2 className="font-heading text-2xl sm:text-3xl font-bold group-hover:text-primary transition-colors">{pick(featured, "title")}</h2>
            <p className="text-muted-foreground mt-3">{pick(featured, "excerpt")}</p>
            <span className="text-primary font-medium mt-5">{t("blog.readGuide")}</span>
          </div>
        </Link>
      )}

      <div className="grid md:grid-cols-3 gap-6">
        {rest.map((p) => (
          <Link key={p.id} to={`/blog/${p.slug}`} className="group block rounded-2xl border border-border overflow-hidden bg-white hover:-translate-y-1 hover:shadow-lg transition-all" data-testid={`blog-card-${p.slug}`}>
            <img src={p.cover_image} alt={p.title} className="h-44 w-full object-cover" />
            <div className="p-5">
              <div className="flex gap-2 mb-2">{p.tags?.slice(0, 2).map((tg) => <span key={tg} className="text-xs bg-primary/5 text-primary rounded-full px-2 py-0.5">{tg}</span>)}</div>
              <h3 className="font-heading font-bold leading-tight group-hover:text-primary transition-colors">{pick(p, "title")}</h3>
              <p className="text-sm text-muted-foreground mt-2 line-clamp-2">{pick(p, "excerpt")}</p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
